<template lang="pug">
  b-overlay(:show="loading || updating", variant="transparent", spinner-variant="primary")
    b-card
      b-row.mb-2
        b-col
          b-form-group
            b-form-input(placeholder="Nombre de documento", v-model="document.name" @input="updateDebounce()")
          b-form-group
            b-form-input(placeholder="Descripción", v-model="document.description", @input="updateDebounce()" )
          b-form-group(label="Filtros")
            p.text-secondary Puedes filtrar los documentos con las siguientes opciones:
            treeselect.mb-2(
              :options="filters",
              placeholder="- Seleccionar filtros -",
              v-model="selectedFilters",
              v-bind="treeselect_options",
              :multiple="true",
              :clearable="false",
              @select="addFilter",
              @deselect="removeFilter"
            )
          b-link(:href="document.link", target="_blank" ) {{fileName}}
        b-col(cols="auto")
          b-form-row.align-items-center
            b-col(cols="auto")
              upload-icon.icon-md.hover-primary.pointer.text-secondary(@click="uploadFileModal = true")
            b-col(cols="auto")
              trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroy('documento')")
      .mb-2 Contenido
      b-card.mb-1(v-for="node in document.nodes", :key="node.id" )
        b-form-group
          template(#label)
            .text-right
              trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroy('contenido', node.id)")
          b-form-textarea(rows="4", v-model="node.text", @input="updateDebounce(node)")
    b-modal(v-model="uploadFileModal",
      centered
      header-class="b-0 pb-0",
      footer-class="b-0",
      cancel-title="Cancelar",
      ok-variant="an"
      ok-title="Actualizar documento",
      :ok-disabled="uploading || !documentFile",
      @ok="loadNewFile",
      @hidden="documentFile = null"
    )
      b-form-group.h-100#document-file-input
        b-file.h-100(placeholder="Selecciona un archivo", v-model="documentFile", :disabled="uploading", accept=".xlsx,.doc,.pdf")
          template(#placeholder)
            .text-center
              upload-icon.icon-xl
              .text-secondary.text-sm Subir archivo
          template(v-slot:file-name="{ names }")
            .text-center
              b-spinner(v-if="uploading", variant="primary")
              file-icon.icon-xl(v-else)
              .text-secondary.text-sm {{names[0]}}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from 'lodash.debounce'
import { UploadFile } from '@/helpers/upload-file'
import treeselectOptions from '@/data/treeselect-options'

const propertyFilterController = createNamespacedHelpers('property_filter')

export default {
  name: 'DocumentView',
  data () {
    return {
      selectedFilters: [],
      treeselect_options: treeselectOptions,
      loading: false,
      uploading: false,
      updating: false,
      uploadFileModal: false,
      documentFile: null,
      document: {
        name: '',
        description: '',
        id: '',
        link: '',
        type: '',
        nodes: []
      }
    }
  },
  computed: {
    ...propertyFilterController.mapState({
      filters: state => state.filters.map(({ _id: id, title: label }) => {
        return { id, label }
      })
    }),
    fileName() {
      try {
        if (!this.document.link) return this.document.link

        return decodeURIComponent(this.document.link.match(/\.com\/.+\.\w{3,4}/gmi)[0].split('/').slice(-1)[0])
      } catch (e) {
        console.log(e.message)
        return this.document.link
      }
    }
  },
  methods: {
    ...mapActions([
      'document/get',
      'document/update',
      'document/destroy',
      'document/updateNode',
      'document/destroyNode',
      'helpers/upload_file',
      'document/addFilter',
      'document/removeFilter',
      'property_filter/all'
    ]),
    isLinkOrDoc() {
      return this.fileName.startsWith('https://') ? 'link' : 'file'
    },
    getFilters () {
      this['property_filter/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    async addFilter() {
      await this.$nextTick()

      this['document/addFilter']({
        account_id: this.$route.params.account_id,
        doc_id: this.$route.params.documentId,
        type: this.isLinkOrDoc(),
        params: {
          Filters: this.selectedFilters,
        },
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          this.$message.success('Filtro agregado')
        }
      })
    },
    async removeFilter(event) {
      this['document/removeFilter']({
        account_id: this.$route.params.account_id,
        doc_id: this.$route.params.documentId,
        type: this.isLinkOrDoc(),
        filter_id: event.id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          this.$message.success('Filtro eliminado')
        }
      })
    },
    getDocument () {
      this.loading = true

      this['document/get']({
        accountId: this.$route.params.account_id,
        id: this.$route.params.documentId,
        callback: res => {
          this.loading = false

          if (res.error) return this.$message.error(res.error)

          this.document = Object.assign(this.document, res.resource)
          this.selectedFilters = res.resource.Filters
        }
      })
    },
    async loadNewFile(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.uploading = true
      this.document.link = await this.getFileUrl()
      const type = this.document.link.split('.').pop()
      this.uploading = false
      this.updateDocument()
    },
    updateDocument() {
      this.updating = true

      this['document/update']({
        accountId: this.$route.params.account_id,
        ...this.document,
        callback: res => {
          this.updating = this.uploadFileModal = false
          if (res.error) return this.$message.error(res.error)
          const { nodes = [] } = res.resource
          this.document.nodes = nodes.slice()
        }
      })
    },
    confirmDestroy (element = 'documento', nodeId) {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar ${element}? No se puede deshacer.`, {
        title: `Eliminar ${element}`,
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
          switch (element) {
            case 'documento':
              this.destroyDocument()
              break
            case 'contenido':
              this.destroyNode(nodeId)
              break
          }
        }
      })
    },
    destroyDocument() {
      this.loading = true

      this['document/destroy']({
        accountId: this.$route.params.account_id,
        id: this.$route.params.documentId,
        callback: res => {
          this.loading = false
          console.log(res)
          if (res.error) return this.$message.error(res.error)
          this.$router.push({name: 'documents'}).catch()
          this.$emit('destroy')
        }
      })
    },
    updateDebounce: _debounce(function (node) {
      if(node) return this.updateNode(node)
      this.updateDocument()
    }, 1000, { leading: false, trailing: true }),
    updateNode(node) {
      this.loading = true

      this['document/updateNode']({
        ...node,
        callback: res => {
          this.loading = false
          if (res.error) this.$message.error(res.error)
        }
      })
    },
    destroyNode(nodeId) {
      this.loading = true

      this['document/destroyNode']({
        accountId: this.$route.params.account_id,
        id: nodeId,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          const index = this.document.nodes.findIndex(el => el.id === nodeId)
          if(index >= 0) {
            this.document.nodes.splice(index, 1)
          }
        }
      })
    },
    getFileUrl() {
      return new Promise(async resolve => {
        const error = 'Error subiendo archivo'
        try {
          const url = await UploadFile.call(this, this.documentFile)
          if(!url) {
            this.$message.error(error)
            return resolve(false)
          }
          return resolve (url)
        } catch (e) {
          console.log(e)
          this.$message.error(error)
          return resolve(false)
        }
      })
    }
  },
  mounted () {
    this.getDocument()
    this.getFilters()
  }
}
</script>

<style scoped>

</style>